import { useTranslation } from "react-i18next";
import { React, useEffect } from "react";
import "react-spring-bottom-sheet/dist/style.css";
import { useSelector } from "react-redux";
import { Interweave } from "interweave";
import useDeviceType from "../utils/useDeviceType";
import Modal from "./Modal";
import { useNavigate } from "react-router-dom"
import useParamNavigation from "../utils/navigation";
import routes from "../routing/routes";

const WidgetInfo = ({ state }) => {
  const { t } = useTranslation();
  const { isOpen, handleClose, title, sectionTitle, sections } = state;
  const { widgetInfo } = useSelector((store) => store.valuationsDetails);
  const { language } = useSelector((store) => store.navigationDetails);
  const { isMobileView, isDesktopView } = useDeviceType();
  const navigate = useNavigate()
  const { pathWithPropId } = useParamNavigation()

  useEffect(() => {
    if (isOpen && isMobileView) {
      navigate(pathWithPropId(routes["main-shell"].children["mobile-widget-info"].path), {
        state: { title, sectionTitle, sections }
      })
    }
  }, [isOpen])

  return (
    <>
      {isDesktopView && isOpen && (
        <Modal isVisible={isOpen} onToggle={handleClose}>
          <div className="w-full mt-7">
            <div className="mx-auto text-center text-xl text-accumin-neutral-1 font-bold w-3/4">
              {t(`${title}`)}
            </div>
          </div>
          <div className="card bg-accumin-secondary-sky-blue mt-6 p-4">
            <div className="text-accumin-neutral-500">
              {t("labels.more-info-details")}
            </div>
          </div>
          <div className="mt-6">
            <div className="text-accumin-neutral-400">
              {t(`${sectionTitle}`)}
            </div>
          </div>
          <div className="card bg-accumin-neutral-100 mt-2 px-4">
            <ul>
              {sections?.map((section, index) => (
                <li
                  className="py-4"
                  key={`section-${section.title}-${index}`}
                >
                  <p className="text-accumin-neutral-350 mb-2">{t(section.title)}</p>
                  <Interweave
                    className="text-accumin-neutral-500"
                    content={widgetInfo?.[language]?.[section.key]} />
                </li>
              ))}
            </ul>
          </div>
        </Modal>
      )}
    </>
  );
};

export default WidgetInfo;
